export const FOTO_WIDTH = 354;
export const FOTO_HEIGHT = 472;

export function compressFoto(file, quality = 0.85) {
  return new Promise((resolve, reject) => {
    if (!file || !file.type || !file.type.startsWith('image/')) {
      reject(new Error('Selecione um arquivo de imagem.'));
      return;
    }

    const url = URL.createObjectURL(file);
    const img = new Image();

    img.onload = () => {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = FOTO_WIDTH;
        canvas.height = FOTO_HEIGHT;
        const ctx = canvas.getContext('2d');

        const proporcao = FOTO_WIDTH / FOTO_HEIGHT;
        let cropW;
        let cropH;
        if (img.width / img.height >= proporcao) {
          cropH = img.height;
          cropW = Math.round(img.height * proporcao);
        } else {
          cropW = img.width;
          cropH = Math.round(img.width / proporcao);
        }
        const sx = (img.width - cropW) / 2;
        const sy = (img.height - cropH) / 2;

        ctx.drawImage(img, sx, sy, cropW, cropH, 0, 0, FOTO_WIDTH, FOTO_HEIGHT);

        canvas.toBlob(
          blob => {
            URL.revokeObjectURL(url);
            if (blob) {
              resolve(blob);
            } else {
              reject(new Error('Não foi possível comprimir a imagem.'));
            }
          },
          'image/jpeg',
          quality
        );
      } catch (err) {
        URL.revokeObjectURL(url);
        reject(err);
      }
    };

    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Não foi possível ler a imagem.'));
    };

    img.src = url;
  });
}

export function blobSizeKb(blob) {
  return Math.round((blob ? blob.size : 0) / 1024);
}